<template>
    <div class="el-button-group">
        <slot></slot>
    </div>
</template>
<script>
    export default {
        name: 'ElButtonGroup'
    };
</script>



// WEBPACK FOOTER //
// button-group.vue?517542c0